import { FC } from 'react';
import { Button, Container, Paper, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUsersControllerConfirmEmailChangeMutation } from 'src/app/services/api.generated';
import LoginTemplate from 'src/components/templates/LoginTemplate';

/**
 * Target of the link mailed to a new email address. The token is only used
 * on the button press, so a mail scanner opening the link does not consume
 * it. The backend gives one answer for wrong, expired and used links.
 */
export const ConfirmEmail: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [confirm, { isLoading, isSuccess, isError }] = useUsersControllerConfirmEmailChangeMutation();

  const invalid = !token || isError;

  return (
    <LoginTemplate>
      <Container maxWidth="xs" sx={{ px: 0 }}>
        <Paper elevation={4}>
          <Stack rowGap={3} sx={{ p: 3 }} data-testid="confirm-email">
            <Typography align="center" fontSize={20} fontWeight={500}>
              {t('confirmEmail.title')}
            </Typography>
            {isSuccess ? (
              <Typography align="center" data-testid="confirm-email-success">
                {t('confirmEmail.success')}
              </Typography>
            ) : invalid ? (
              <Typography align="center" data-testid="confirm-email-invalid">
                {t('confirmEmail.invalid')}
              </Typography>
            ) : (
              <Typography align="center">{t('confirmEmail.body')}</Typography>
            )}
            <Stack rowGap={1}>
              {!isSuccess && !invalid && (
                <LoadingButton size="large" fullWidth variant="contained" loading={isLoading} onClick={() => confirm({ confirmEmailChangeDto: { token } })}>
                  {t('confirmEmail.button')}
                </LoadingButton>
              )}
              <Button size="large" fullWidth variant="outlined" onClick={() => navigate('/login')}>
                {t('sendMail.back')}
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    </LoginTemplate>
  );
};
